import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import PropertyCard from '../properties/PropertyCard.jsx'
import { getSocietiesFromSheet } from '../../services/localDataService'

const FeaturedProperties = () => {
  const [properties, setProperties] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const result = await getSocietiesFromSheet()
        if (result.success) {
          // Show the first 4 unique societies
          setProperties(result.data.slice(0, 4))
        } else {
          console.error('Failed to fetch societies:', result.error)
          setError('Failed to load properties')
        }
      } catch (err) {
        console.error('Error fetching societies:', err)
        setError('An error occurred while loading properties.')
      } finally {
        setLoading(false)
      }
    }

    fetchProperties()
  }, [])

  if (loading) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Featured Properties
            </h2>
            <p className="text-gray-600 text-lg">Loading amazing properties...</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="bg-white rounded-xl shadow-md h-80 animate-pulse"></div>
            ))}
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-secondary-900 mb-4">
            Exclusive Stays for Women
          </h2>
          <p className="text-secondary-600 text-lg max-w-2xl mx-auto">
            Discover our handpicked selection of premium, highly-secure PG accommodations designed for your comfort and safety.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {error ? (
            <div className="col-span-full text-center py-8">
              <p className="text-red-600">{error}</p>
            </div>
          ) : properties.length === 0 ? (
            <div className="col-span-full text-center py-8">
              <p className="text-gray-600">No properties available at the moment.</p>
            </div>
          ) : (
            properties.map((property, index) => (
              <motion.div
                key={property.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <PropertyCard property={property} />
              </motion.div>
            ))
          )}
        </div>

        <div className="text-center mt-12">
          <Link to="/properties" className="btn-primary inline-block">
            View All Properties
          </Link>
        </div>
      </div>
    </section>
  )
}

export default FeaturedProperties